exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2gLHKHXtR9O249MufFTTfX{width:30%;& ul{width:100px;list-style:none;html[dir] & li{margin:10px 0}}html[dir] & ul{padding:0 20px}}html[dir=ltr] ._2gLHKHXtR9O249MufFTTfX{border-right:solid 1px #c8c8c8;margin-right:16px;padding-right:16px}html[dir=rtl] ._2gLHKHXtR9O249MufFTTfX{border-left:solid 1px #c8c8c8;margin-left:16px;padding-left:16px}", ""]);
// Exports
exports.locals = {
	"sidebar": "_2gLHKHXtR9O249MufFTTfX"
};